import Vue from "vue";
import VueI18n from "vue-i18n";

import enUS from "./en-US";
import esES from "./es-ES";

const messages = { "en-US": enUS, "es-ES": esES };

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: "en-US",
  fallbackLocale: "en-US",
  messages
});

export default i18n;
